var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuFigmaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9996 3.63916V18.1991H18.6396V8.99915C18.6396 7.5776 19.2044 6.21425 20.2095 5.20905C21.2147 4.20386 22.5781 3.63916 23.9996 3.63916Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8799 18.1191H23.9999V24.8391C23.9999 25.2422 23.8397 25.6289 23.5547 25.9139C23.2696 26.199 22.883 26.3591 22.4799 26.3591H22.3999C21.9967 26.3591 21.6101 26.199 21.3251 25.9139C21.04 25.6289 20.8799 25.2422 20.8799 24.8391V18.1191Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2404 26.359C9.75241 26.359 9.2844 26.1652 8.93933 25.8201C8.59426 25.475 8.40039 25.007 8.40039 24.519L9.20039 14.519H11.3604L12.1604 24.519C12.1606 24.7675 12.1105 25.0135 12.0131 25.2421C11.9157 25.4708 11.7729 25.6773 11.5935 25.8492C11.4141 26.0212 11.2017 26.155 10.9691 26.2426C10.7366 26.3302 10.4887 26.3698 10.2404 26.359Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.24 14.519C12.5817 14.519 14.48 12.155 14.48 9.23897C14.48 6.32292 12.5817 3.95898 10.24 3.95898C7.89833 3.95898 6 6.32292 6 9.23897C6 12.155 7.89833 14.519 10.24 14.519Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuFigmaIcon);
export default __webpack_public_path__ + "static/media/MenuFigmaIcon.af92512de97153bbc98ca60625d1b2fd.svg";
export { ForwardRef as ReactComponent };